import { Location } from 'react-router-dom'

export const getModalPath = (location: Location, path: string) => {
  return location.pathname.indexOf(path) > 0
    ? location.pathname.substring(1)
    : `${location.pathname.substring(1)}/${path}`
}
